import { CustomImage, type CustomImageProps } from "@/components/ui/image";
import { getSiteConfig } from "@/lib/config";

export type LogoVariant = "primary" | "dark" | "square" | "diagrams";

export interface LogoProps extends Omit<CustomImageProps, "src" | "alt"> {
  variant?: LogoVariant;
  alt?: string;
}

export function Logo({ variant = "diagrams", alt, ...props }: LogoProps) {
  const config = getSiteConfig();
  return (
    <CustomImage
      src={config.branding.logo[variant]}
      alt={alt ?? config.company.name}
      {...props}
    />
  );
}
